import { useContext } from 'react'
import { Box, Stack, IconButton, Typography } from '@mui/material'
import CloseIcon from "@mui/icons-material/Close";
import { DataDispatchContext } from '../../contexts/data/dataContext'
import custom from '../../styles/mui/szVariables.json'

export default function RightPanel({ title, children }: any) {
    const border = custom.border
    const dispatch: any = useContext(DataDispatchContext)
   
    const handleClose = () => {
        dispatch({
            type: 'setRightPanel',
            rightPanel: null
        })
    }

    return (
        <Box display="flex" 
            justifyContent={"center"}
            flexDirection={"row"}
            alignContent={"center"}>              
            <Box display="flex" 
                justifyContent={"center"}
                flexDirection={"row"}
                alignContent={"center"}
                sx={{ 
                    backgroundColor: 'sz.colors.background',                         
                    position: 'fixed', 
                    top: custom.sizes.hf,
                    boxSizing: "border-box",
                    height: custom.sizes.hf,
                    borderBottom: border,  
                    zIndex: 99,
                    width: {
                        xs:'98%', 
                        sm:'320px', 
                        md:'400px', 
                        lg:'400px' 
                    },
                }} >
                <Stack alignItems="center" direction="row" 
                    width={{
                        xs:'95%', 
                        sm:'310px', 
                        md:'400px', 
                        lg:'400px' 
                    }}
                    maxWidth={{
                        xs:'100%', 
                        sm:'400px', 
                        md:'400px', 
                        lg:'400px' 
                    }}
                    >
                    <Typography component={"h3"} 
                        variant="szHeading.Bold.Small" 
                        ml={custom.spacing.sm}
                        id="rightPanelTitle">
                            {title}
                    </Typography>
                    <IconButton id="rightPanelCloseButton" 
                        onClick={handleClose} 
                        sx={{ ml: 'auto', cursor: 'pointer' }}>
                        <CloseIcon sx={{ 
                                width: '20px', 
                                height: '20px',
                                p: custom.spacing.xxs,
                                mr: custom.spacing.xs,  
                                border, 
                                borderRadius: custom.corners3, 
                                background: '#FFF' 
                            }} />
                    </IconButton>
                </Stack>
            </Box>
            <Box display="flex" id="rightPanelContent" 
                    flexDirection={"column"} 
                    justifyContent={"flex-start"}
                    alignItems={"flex-start"}
                    alignContent={"flex-start"}
                    // position = 'fixed' 
                    // top={custom.sizes.rp}
                sx={{
                    boxSizing: "border-box",
                    maxWidth: {
                        xs:'100%', 
                        sm:'400px', 
                        md:'400px', 
                        lg:'400px' 
                    },
                    width: "100%",
                    height: {
                        xs: 'auto', 
                        sm: '80vh', 
                        md: '85vh', 
                        lg: '80vh',
                        xl: '90vh',
                        xxl: '90vh'
                    },
                    overflowX: 'hidden',
                    overflowY: 'scroll',
                    '&::-webkit-scrollbar': {
                        display: "none"
                    },
                    pb: 1
                }} >  
                { children }
            </Box>
        </Box>   
    )
}